/**
 * SEEDBOY SEEDS PDP - JavaScript v5
 * Gallery slides, hero tabs, hero FAQ, sticky mobile ATC, video, Klaviyo.
 * Purchase toggle is handled inline in seeds-product-hero.liquid.
 */
(function() {
  'use strict';

  function qs(sel, ctx) { return (ctx || document).querySelector(sel); }
  function qsa(sel, ctx) { return Array.from((ctx || document).querySelectorAll(sel)); }


  /* ============================================================
     HERO GALLERY
     ============================================================ */
  function initGallery() {
    var slides = qsa('.seeds-hero__slide');
    var thumbs = qsa('.seeds-hero__thumb');
    var prevBtn = qs('.seeds-hero__thumb-prev');
    var nextBtn = qs('.seeds-hero__thumb-next');
    if (!slides.length) return;

    var currentIdx = 0;

    function goTo(idx) {
      if (idx < 0) idx = slides.length - 1;
      if (idx >= slides.length) idx = 0;
      currentIdx = idx;
      slides.forEach(function(s) { s.classList.toggle('is-active', parseInt(s.dataset.index, 10) === idx); });
      thumbs.forEach(function(t) {
        var isActive = parseInt(t.dataset.index, 10) === idx;
        t.classList.toggle('is-active', isActive);
        t.setAttribute('aria-selected', isActive ? 'true' : 'false');
      });
    }

    thumbs.forEach(function(thumb) {
      thumb.addEventListener('click', function() { goTo(parseInt(this.dataset.index, 10)); });
    });

    if (prevBtn) prevBtn.addEventListener('click', function() { goTo(currentIdx - 1); });
    if (nextBtn) nextBtn.addEventListener('click', function() { goTo(currentIdx + 1); });

    /* Gallery overlay arrows */
    var galleryPrev = qs('.seeds-hero__gallery-prev');
    var galleryNext = qs('.seeds-hero__gallery-next');
    if (galleryPrev) galleryPrev.addEventListener('click', function() { goTo(currentIdx - 1); });
    if (galleryNext) galleryNext.addEventListener('click', function() { goTo(currentIdx + 1); });

    /* Mobile swipe */
    var gallery = qs('.seeds-hero__gallery');
    if (gallery && 'ontouchstart' in window) {
      var startX = 0;
      gallery.addEventListener('touchstart', function(e) { startX = e.touches[0].clientX; }, { passive: true });
      gallery.addEventListener('touchend', function(e) {
        var diff = startX - e.changedTouches[0].clientX;
        if (Math.abs(diff) < 50) return;
        goTo(diff > 0 ? currentIdx + 1 : currentIdx - 1);
      }, { passive: true });
    }

    /* Keyboard nav */
    document.addEventListener('keydown', function(e) {
      if (e.target.closest('.seeds-hero__gallery, .seeds-hero__thumbs')) {
        if (e.key === 'ArrowLeft') { e.preventDefault(); goTo(currentIdx - 1); }
        if (e.key === 'ArrowRight') { e.preventDefault(); goTo(currentIdx + 1); }
      }
    });
  }


  /* ============================================================
     HERO TABS
     ============================================================ */
  function initHeroTabs() {
    var btns = qsa('.seeds-hero__tab-btn');
    var panels = qsa('.seeds-hero__tab-panel');
    if (!btns.length) return;

    btns.forEach(function(btn) {
      btn.addEventListener('click', function() {
        var target = this.getAttribute('aria-controls');
        btns.forEach(function(b) {
          b.setAttribute('aria-selected', 'false');
          b.classList.remove('is-active');
          b.tabIndex = -1;
        });
        panels.forEach(function(p) { p.classList.remove('is-active'); p.setAttribute('aria-hidden', 'true'); });
        this.setAttribute('aria-selected', 'true');
        this.classList.add('is-active');
        this.tabIndex = 0;
        var panel = document.getElementById(target);
        if (panel) { panel.classList.add('is-active'); panel.setAttribute('aria-hidden', 'false'); }
      });
    });

    /* Arrow key nav */
    var nav = qs('.seeds-hero__tabs-nav');
    if (nav) {
      nav.addEventListener('keydown', function(e) {
        var idx = btns.indexOf(document.activeElement);
        if (idx === -1) return;
        var next = -1;
        if (e.key === 'ArrowRight') next = (idx + 1) % btns.length;
        else if (e.key === 'ArrowLeft') next = (idx - 1 + btns.length) % btns.length;
        if (next >= 0) { e.preventDefault(); btns[next].focus(); btns[next].click(); }
      });
    }
  }


  /* ============================================================
     HERO FAQ
     ============================================================ */
  function initHeroFaq() {
    var triggers = qsa('.seeds-hero__faq-trigger');
    if (!triggers.length) return;

    triggers.forEach(function(trigger) {
      trigger.addEventListener('click', function() {
        var target = this.getAttribute('aria-controls');
        var content = document.getElementById(target);
        var isOpen = this.getAttribute('aria-expanded') === 'true';

        triggers.forEach(function(t) { t.setAttribute('aria-expanded', 'false'); });
        qsa('.seeds-hero__faq-content').forEach(function(c) { c.classList.remove('is-open'); });

        if (!isOpen) {
          this.setAttribute('aria-expanded', 'true');
          if (content) content.classList.add('is-open');
        }
      });

      /* Keyboard: Enter and Space */
      trigger.addEventListener('keydown', function(e) {
        if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); this.click(); }
      });
    });
  }


  /* ============================================================
     STANDALONE TABS (below-fold section)
     ============================================================ */
  function initTabs() {
    var tabBtns = qsa('.seeds-pdp__tab-btn');
    var panels = qsa('.seeds-pdp__tab-panel');
    var accordionBtns = qsa('.seeds-pdp__tab-accordion-btn');
    if (!tabBtns.length) return;

    tabBtns.forEach(function(btn) {
      btn.addEventListener('click', function() {
        var target = this.getAttribute('aria-controls');
        tabBtns.forEach(function(b) { b.setAttribute('aria-selected', 'false'); b.tabIndex = -1; });
        panels.forEach(function(p) { p.setAttribute('aria-hidden', 'true'); });
        this.setAttribute('aria-selected', 'true');
        this.tabIndex = 0;
        var panel = document.getElementById(target);
        if (panel) panel.setAttribute('aria-hidden', 'false');
      });
    });

    /* Arrow key nav (WAI-ARIA tabs pattern) */
    var tabList = tabBtns[0] && tabBtns[0].parentElement;
    if (tabList) {
      tabList.addEventListener('keydown', function(e) {
        var idx = tabBtns.indexOf(document.activeElement);
        if (idx === -1) return;
        var next = -1;
        if (e.key === 'ArrowRight') next = (idx + 1) % tabBtns.length;
        else if (e.key === 'ArrowLeft') next = (idx - 1 + tabBtns.length) % tabBtns.length;
        else if (e.key === 'Home') next = 0;
        else if (e.key === 'End') next = tabBtns.length - 1;
        if (next >= 0) { e.preventDefault(); tabBtns[next].focus(); tabBtns[next].click(); }
      });
    }

    accordionBtns.forEach(function(btn) {
      btn.addEventListener('click', function() {
        var target = this.getAttribute('aria-controls');
        var panel = document.getElementById(target);
        var isOpen = this.getAttribute('aria-expanded') === 'true';
        accordionBtns.forEach(function(b) { b.setAttribute('aria-expanded', 'false'); });
        panels.forEach(function(p) { p.classList.remove('is-open'); });
        if (!isOpen) {
          this.setAttribute('aria-expanded', 'true');
          if (panel) panel.classList.add('is-open');
        }
      });
    });
  }


  /* ============================================================
     STANDALONE FAQ (below-fold section)
     ============================================================ */
  function initFaq() {
    var triggers = qsa('.seeds-pdp__faq-trigger');
    if (!triggers.length) return;

    triggers.forEach(function(trigger) {
      trigger.addEventListener('click', function() {
        var target = this.getAttribute('aria-controls');
        var content = document.getElementById(target);
        var isOpen = this.getAttribute('aria-expanded') === 'true';
        triggers.forEach(function(t) { t.setAttribute('aria-expanded', 'false'); });
        qsa('.seeds-pdp__faq-content').forEach(function(c) { c.classList.remove('is-open'); });
        if (!isOpen) {
          this.setAttribute('aria-expanded', 'true');
          if (content) content.classList.add('is-open');
        }
      });
    });
  }


  /* ============================================================
     STICKY MOBILE ATC
     ============================================================ */
  function initStickyBar() {
    var stickyBar = document.getElementById('seedsStickyBar');
    var atcBtn = document.getElementById('seedsAtcBtn');
    if (!stickyBar || !atcBtn) return;
    if (window.innerWidth >= 769) return;

    var observer = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        stickyBar.classList.toggle('is-visible', !entry.isIntersecting);
        stickyBar.setAttribute('aria-hidden', entry.isIntersecting ? 'true' : 'false');
      });
    }, { threshold: 0 });

    observer.observe(atcBtn);
  }


  /* ============================================================
     VIDEO LAZY LOAD
     ============================================================ */
  function initVideo() {
    qsa('.seeds-pdp__video-wrap').forEach(function(wrap) {
      var playBtn = qs('.seeds-pdp__video-play', wrap);
      var thumb = qs('.seeds-pdp__video-thumb', wrap);
      var videoUrl = wrap.dataset.videoUrl;
      if (!playBtn || !videoUrl) return;

      playBtn.addEventListener('click', function() {
        var embedUrl = getEmbedUrl(videoUrl);
        if (!embedUrl) return;
        var iframe = document.createElement('iframe');
        iframe.className = 'seeds-pdp__video-iframe';
        iframe.src = embedUrl;
        iframe.setAttribute('allow', 'autoplay; fullscreen');
        iframe.setAttribute('allowfullscreen', '');
        if (thumb) thumb.style.display = 'none';
        playBtn.style.display = 'none';
        wrap.appendChild(iframe);
      });
    });
  }

  function getEmbedUrl(url) {
    var yt = url.match(/(?:youtube\.com\/(?:watch\?v=|embed\/)|youtu\.be\/)([^&?/]+)/);
    if (yt) return 'https://www.youtube.com/embed/' + yt[1] + '?autoplay=1&rel=0';
    var vm = url.match(/vimeo\.com\/(\d+)/);
    if (vm) return 'https://player.vimeo.com/video/' + vm[1] + '?autoplay=1';
    return url;
  }


  /* ============================================================
     KLAVIYO ATC
     ============================================================ */
  function initKlaviyoATC() {
    var form = qs('[data-product-form]');
    if (!form) return;

    form.addEventListener('submit', function() {
      var _learnq = window._learnq || [];
      var sellingPlanInput = document.getElementById('sellingPlanInput');
      var isSubscription = sellingPlanInput && sellingPlanInput.value !== '';
      var priceEl = qs('.seeds-hero__option.is-selected .seeds-hero__option-price');
      var price = priceEl ? parseFloat(priceEl.textContent.replace(/[^0-9.]/g, '')) : 0;
      var titleEl = qs('.seeds-hero__title');
      var freqSelect = document.getElementById('seedsFrequency');
      var freqName = (isSubscription && freqSelect) ? freqSelect.options[freqSelect.selectedIndex].text : 'one-time';

      _learnq.push(['track', 'Added to Cart', {
        ProductName: titleEl ? titleEl.textContent.trim() : '',
        Price: price,
        Quantity: 1,
        IsSubscription: isSubscription,
        SubscriptionFrequency: freqName
      }]);
    });
  }


  /* ============================================================
     INIT
     ============================================================ */
  document.addEventListener('DOMContentLoaded', function() {
    initGallery();
    initHeroTabs();
    initHeroFaq();
    initTabs();
    initFaq();
    initStickyBar();
    initVideo();
    initKlaviyoATC();
  });

})();